import {
    ICadastrarFormularioProduto,
    ICadastrarPerguntaFormularioProduto,
    ICadastrarRespostaFormularioProduto,
    ICadastroEmpreendimentoDTO,
    IResponderFormularioProduto,
} from "../../../Interfaces/Geral/Produtos/ProdutosInterface";
import {
    AtualizarProdutoService,
    CadastrarFormularioProdutoService,
    CadastrarPerguntaFormularioProdutoService,
    CadastrarProdutoService,
    CadastrarRespostaFormularioProdutoService,
    DeletarFormularioProdutoService,
    DeletarPerguntaFormularioProdutoService,
    DeletarRespostaEnviadaFormularioProdutoService,
    DeletarRespostaFormularioProdutoService,
    DeletarRespostasEnviadasFormularioProdutoService,
    EditarFormularioProdutoService,
    EditarPerguntaFormularioProdutoService,
    EditarRespostaFormularioProdutoService,
    getEmpreendimentoVendasService,
    ListarBlocosEmpreendimentoEmccampService,
    ListarBlocosEmpreendimentoService,
    ListarClassificacaoProdutoService,
    ListarEmpreendimentosService,
    ListarPerguntasFormularioProdutoService,
    ListarProdutosArvoreService,
    ListarProdutosPorEmpreendimentosService,
    ListarProdutosService,
    ListarRegiaoService,
    ListarRespostaFormularioProdutoService,
    ListarRespostasFormularioProdutoService,
    ListarSegmentoService,
    ListarSituacaoComercialService,
    ListarSituacaoObraService,
    ListarTipoIncorporacaoService,
    ListarUnidadesByIdEmpreendimentoService,
    ListarUnidadesService,
    ObterFormularioProdutoService,
    ResponderFormularioProdutoService,
} from "../../../Services/Geral/Produtos/ProdutosServices";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function ListarEmpreendimentosController() {
    return await ListarEmpreendimentosService()
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function ListarEmpreendimentosModuloController(
    id_tipo_caso: number
) {
    return await ListarEmpreendimentosService(false, "", id_tipo_caso)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function ListarEmpreendimentosPesquisaController(
    pesquisa: string
) {
    return Controller(ListarEmpreendimentosService(undefined, pesquisa ?? ""));
}

export async function ListarEmpreendimentosComObraController() {
    return await ListarEmpreendimentosService(true)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function ListarProdutosController(idEmpreendimento: number) {
    return await ListarProdutosService(idEmpreendimento)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function ListarUnidadesController(idProduto: number) {
    return await ListarUnidadesService(idProduto)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function ListarUnidadesByIdEmpreendimentoController(
    idProduto: number
) {
    return await ListarUnidadesByIdEmpreendimentoService(idProduto)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export function ListarProdutosPorEmpreendimentosController(requestBody: {
    ID_EMPREENDIMENTO: string | number[];
}) {
    return Controller(ListarProdutosPorEmpreendimentosService(requestBody));
}

export function ListarBlocosEmpreendimentoController(
    ID_EMPREENDIMENTO: string | number[]
) {
    return Controller(ListarBlocosEmpreendimentoService(ID_EMPREENDIMENTO));
}

export function ListarBlocosEmpreendimentoEmccampController(
    ID_EMPREENDIMENTO: string | number[]
) {
    return Controller(
        ListarBlocosEmpreendimentoEmccampService(ID_EMPREENDIMENTO)
    );
}

export async function ListarUnidadesPorEmpreendimentoController(
    idEmpreendimento: number
) {
    return idEmpreendimento > 0
        ? await ListarProdutosService(idEmpreendimento)
              .then(async (response) => {
                  return await Promise.all(
                      response.data.map(async (produto) => {
                          return await ListarUnidadesController(
                              produto.ID_PRODUTO
                          );
                      })
                  ).then((unidades) => {
                      return unidades.reduce((todasUnidades, unidade) => {
                          return todasUnidades.concat(unidade);
                      }, []);
                  });
              })
              .catch((err) => {
                  ValidationErr(err);
                  throw err;
              })
        : [];
}

export async function ListarProdutosComUnidadesController(
    idEmpreendimento: number
) {
    return await ListarProdutosService(idEmpreendimento)
        .then(async (response) => {
            return await Promise.all(
                response.data.map(async (produto) => {
                    produto.UNIDADES = await ListarUnidadesController(
                        produto.ID_PRODUTO
                    );
                    return produto;
                })
            );
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
}

export async function CadastrarProdutoController(
    data: ICadastroEmpreendimentoDTO
) {
    return Controller(CadastrarProdutoService(data));
}

export async function ListarClassificacaoProdutoController() {
    return Controller(ListarClassificacaoProdutoService());
}

export async function ListarProdutosArvoreController() {
    return Controller(ListarProdutosArvoreService());
}

export async function AtualizarProdutoController(
    data: ICadastroEmpreendimentoDTO
) {
    return Controller(AtualizarProdutoService(data));
}

export async function getEmpreendimentoVendasController(ID_PRODUTO: number) {
    return Controller(getEmpreendimentoVendasService(ID_PRODUTO));
}

export async function ListarSegmentoController() {
    return Controller(ListarSegmentoService());
}

export async function ListarSituacaoObraController() {
    return Controller(ListarSituacaoObraService());
}

export async function ListarSituacaoComercialController() {
    return Controller(ListarSituacaoComercialService());
}

export async function ListarTipoIncorporacaoController() {
    return Controller(ListarTipoIncorporacaoService());
}

export async function ListarRegiaoController() {
    return Controller(ListarRegiaoService());
}

export async function ObterFormularioProdutoController(
    idProduto: number,
    flListagemCompleta?: boolean
) {
    return Controller(
        ObterFormularioProdutoService(idProduto, flListagemCompleta)
    );
}

export async function CadastrarFormularioProdutoController(
    requestBody: ICadastrarFormularioProduto
) {
    return Controller(CadastrarFormularioProdutoService(requestBody));
}

export async function EditarFormularioProdutoController(
    requestBody: ICadastrarFormularioProduto
) {
    return Controller(EditarFormularioProdutoService(requestBody));
}

export async function DeletarFormularioProdutoController(
    idFormularioProduto: number
) {
    return Controller(DeletarFormularioProdutoService(idFormularioProduto));
}

export async function ListarPerguntasFormularioProdutoController(
    idFormularioProduto: number
) {
    return Controller(
        ListarPerguntasFormularioProdutoService(idFormularioProduto)
    );
}

export async function CadastrarPerguntaFormularioProdutoController(
    requestBody: ICadastrarPerguntaFormularioProduto
) {
    return Controller(CadastrarPerguntaFormularioProdutoService(requestBody));
}

export async function EditarPerguntaFormularioProdutoController(
    requestBody: ICadastrarPerguntaFormularioProduto
) {
    return Controller(EditarPerguntaFormularioProdutoService(requestBody));
}

export async function DeletarPerguntaFormularioProdutoController(
    idFormularioPergunta: number
) {
    return Controller(
        DeletarPerguntaFormularioProdutoService(idFormularioPergunta)
    );
}

export async function ListarRespostasFormularioProdutoController(
    idFormularioPergunta: number
) {
    return Controller(
        ListarRespostasFormularioProdutoService(idFormularioPergunta)
    );
}

export async function CadastrarRespostaFormularioProdutoController(
    requestBody: ICadastrarRespostaFormularioProduto
) {
    return Controller(CadastrarRespostaFormularioProdutoService(requestBody));
}

export async function EditarRespostaFormularioProdutoController(
    requestBody: ICadastrarRespostaFormularioProduto
) {
    return Controller(EditarRespostaFormularioProdutoService(requestBody));
}

export async function DeletarRespostaFormularioProdutoController(
    idFormularioResposta: number
) {
    return Controller(
        DeletarRespostaFormularioProdutoService(idFormularioResposta)
    );
}

export async function ListarRespostaFormularioProdutoController(
    idFormularioPergunta: number
) {
    return Controller(
        ListarRespostaFormularioProdutoService(idFormularioPergunta)
    );
}

export async function ResponderFormularioProdutoController(
    requestBody: Array<IResponderFormularioProduto>
) {
    return Controller(ResponderFormularioProdutoService(requestBody));
}

export async function DeletarRespostaEnviadaFormularioProdutoController(
    idRespostaFormularioProduto: number
) {
    return Controller(
        DeletarRespostaEnviadaFormularioProdutoService(
            idRespostaFormularioProduto
        )
    );
}

export async function DeletarRespostasEnviadasFormularioProdutoController(
    idRespostaFormularioProduto: number
) {
    return Controller(
        DeletarRespostasEnviadasFormularioProdutoService(
            idRespostaFormularioProduto
        )
    );
}
